
<template>
  <v-container fluid id="receivable-summary">
    <v-row>
      <v-col cols="12" lg="9" xl="10">
        <ProductSummaryTable :productSummary="productionSummaryObject.productSummary || []"/>
      </v-col>
      <v-col cols="12" lg="3" xl="2">
        <ProductSummaryChart :productSummary="productionSummaryObject.productSummary || []"/>
      </v-col>
    </v-row>
    <v-row>
      <v-expansion-panels accordion popout v-model="openPanels" tile>
        <v-expansion-panel v-for="(production, index) in productionSummaryObject.production" :key="`production-${index}`">
          <v-expansion-panel-header id="destination-panel-header">
            <v-row dense>
              <v-col cols="auto">
                <v-icon small>
                  mdi-domain
                </v-icon>
                {{production.name}}
              </v-col>
            </v-row>
            <template #actions>
              <v-container>
                <v-row justify="end">
                  {{getTotalAmountForProductionPanel(production)}}
                </v-row>
                <v-row justify="end">
                  {{getTotalWeightForProductionPanel(production)}}
                </v-row>
                <v-row justify="end">
                  {{getTotalLoadsForProductionPanel(production)}}
                </v-row>
              </v-container>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="lg_expansion-panel_wrapper">
              <ProductionCard
              :production="production"
              class="mt-2"
              />
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-container>
</template>

<script>
import { tonStringFromPounds, formatMoney } from '@/utils/NumericMutations.js'
import { mapGetters } from 'vuex'
export default {
  name: 'ReceivableProductionSummary',

  props: {
    productionSummaryObject: {
      type: Object,
      required: true
    }
  },

  components: {
    ProductSummaryTable: () => import('@/components/settlements/accounts-payable-module/production-summary/ProductSummaryTable.vue'),
    ProductSummaryChart: () => import('@/components/settlements/accounts-payable-module/production-summary/ProductSummaryChart.vue'),
    ProductionCard: () => import('@/components/settlements/accounts-receivable-module/production-summary/ProductionCard.vue')
  },

  data: () => ({
    openPanels: []
  }),

  created () {
    this.openPanels = this.productionSummaryObject.productSummary.length === 1 ? [0] : []
  },

  computed: {
    ...mapGetters('settlements', ['useMetricTons'])
  },

  methods: {
    formatMoney,
    getTotalWeightForProductionPanel ({ productionDetails, logYardSaleDetails }) {
      let totalWeight = 0

      logYardSaleDetails.forEach((detail) => {
        totalWeight += detail.productSummaries.reduce((a, b) => a + b.weight, 0)
      })

      productionDetails.forEach((productionDetail) => {
        totalWeight += productionDetail.tractProduction.reduce((a, b) => a + b.weight, 0)
      })

      return this.useMetricTons
        ? this.$t('metricTonsTotal', { totalWeight: tonStringFromPounds(totalWeight, 3, this.useMetricTons) })
        : this.$t('shortTonsTotal', { totalWeight: tonStringFromPounds(totalWeight, 3, this.useMetricTons) })
    },
    getTotalLoadsForProductionPanel ({ productionDetails, logYardSaleDetails }) {
      let totalLoads = 0

      logYardSaleDetails.forEach((detail) => {
        totalLoads += detail.productSummaries.reduce((a, b) => a + b.loads, 0)
      })

      productionDetails.forEach((detail) => {
        totalLoads += detail.tractProduction.reduce((a, b) => a + b.loads, 0)
      })

      const loadText = totalLoads > 1 ? 'loads' : 'load'
      return `${totalLoads} ${loadText}`
    },

    getTotalAmountForProductionPanel ({ productionDetails, logYardSaleDetails }) {
      let totalAmount = 0

      logYardSaleDetails.forEach((detail) => {
        totalAmount += detail.productSummaries.reduce((a, b) => a + b.amount, 0)
      })

      productionDetails.forEach((detail) => {
        totalAmount += detail.tractProduction.reduce((a, b) => a + b.amount, 0)
      })

      return formatMoney(totalAmount)
    }
  }
}
</script>
